{
  "v2.espaces.accorder_droit_isole": "Accorder un droit isolé",
  "v2.espaces.ajouter.ajoute": "Membre ajouté comme lecteur.",
  "v2.espaces.ajouter.ajouter": "Ajouter",
  "v2.espaces.ajouter.aucun": "Personne ne correspond dans l’annuaire de l’organisation.",
  "v2.espaces.ajouter.choisir": "Choisissez une personne.",
  "v2.espaces.ajouter.deja_membre": "{{nom}} (déjà membre)",
  "v2.espaces.ajouter.echec": "L’ajout n’a pas abouti.",
  "v2.espaces.ajouter.lecteur_programme": "La personne arrive comme Lecteur de programme ; un autre profil se donne ensuite par « Gérer les profils ».",
  "v2.espaces.ajouter.lecteur_projet": "La personne arrive comme Lecteur ; un autre profil se donne ensuite par « Gérer les profils », avec le droit d’attribuer.",
  "v2.espaces.ajouter.quelqu_un_d_autre": "Déjà membre : choisissez quelqu’un d’autre.",
  "v2.espaces.ajouter.recherche": "Rechercher dans l’annuaire de l’organisation",
  "v2.espaces.ajouter.resultats": "Personnes trouvées",
  "v2.espaces.ajouter.titre_programme": "Ajouter un membre au programme",
  "v2.espaces.ajouter.titre_projet": "Ajouter un membre de l’organisation au projet",
  "v2.espaces.ajouter_membre": "Ajouter un membre",
  "v2.espaces.annuler": "Annuler",
  "v2.espaces.code.ACCESS_REQUEST_NOT_FOUND": "Cette demande n’existe plus.",
  "v2.espaces.code.ACCESS_REQUEST_NOT_PENDING": "Cette demande a déjà été décidée par une autre personne.",
  "v2.espaces.code.ACCESS_REQUEST_SELF_DECISION": "On ne décide pas sa propre demande.",
  "v2.espaces.code.ALREADY_MEMBER": "Cette personne est déjà membre.",
  "v2.espaces.code.COMPTE_DESACTIVE": "Ce compte est désactivé.",
  "v2.espaces.code.CONFLIT_CONCURRENT": "Ce membre a été modifié entre-temps : sa fiche est relue, recommencez.",
  "v2.espaces.code.CORPS_HISTORIQUE_RETIRE": "Requête d’un ancien format, refusée.",
  "v2.espaces.code.DROIT_HORS_NIVEAU": "Ce droit n’appartient pas à ce niveau.",
  "v2.espaces.code.DROIT_ISOLE_INTROUVABLE": "Ce droit isolé n’existe plus.",
  "v2.espaces.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire.",
  "v2.espaces.code.DROIT_PERSONNEL_NON_ACCORDABLE": "Ce droit est personnel : il ne s’accorde pas.",
  "v2.espaces.code.DROIT_RESERVE_AU_PROPRIETAIRE": "Ce droit est réservé au propriétaire : il ne s’accorde pas en isolé.",
  "v2.espaces.code.ECHEANCE_PASSEE": "La date de fin doit être dans le futur.",
  "v2.espaces.code.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "Ce domaine d’adresse est refusé par la politique de l’organisation.",
  "v2.espaces.code.LAST_OWNER": "Le dernier propriétaire ne peut pas être retiré : transférez d’abord la propriété.",
  "v2.espaces.code.MOTIF_TROP_COURT": "Le motif compte 15 caractères au moins.",
  "v2.espaces.code.NOT_FOUND": "Introuvable : la personne ou le projet n’existe plus.",
  "v2.espaces.code.PERSONNE_NON_MEMBRE": "Cette personne n’est pas membre : ajoutez-la d’abord.",
  "v2.espaces.code.PROFIL_INCONNU": "Ce profil n’est pas publié dans l’organisation.",
  "v2.espaces.code.PROFIL_NIVEAU_INCOMPATIBLE": "Ce profil ne se pose pas à ce niveau.",
  "v2.espaces.code.PROGRAM_LAST_OWNER": "Le dernier propriétaire du programme ne peut pas être retiré : transférez d’abord la propriété.",
  "v2.espaces.code.PROGRAM_MEMBER_EXISTS": "Cette personne est déjà membre.",
  "v2.espaces.code.PROGRAM_MEMBER_NOT_FOUND": "Cette personne n’est pas (ou plus) membre du programme.",
  "v2.espaces.code.PROGRAM_MEMBER_UNKNOWN_USER": "Cette personne est inconnue de l’organisation.",
  "v2.espaces.code.RESOURCE_UNAVAILABLE": "Introuvable ou indisponible.",
  "v2.espaces.code.RETRAIT_DE_SOI": "On ne se retire pas soi-même d’un projet.",
  "v2.espaces.code.VALIDATION_ERROR": "Saisie invalide.",
  "v2.espaces.confirmer_retrait_droit_isole": "Confirmer le retrait du droit isolé",
  "v2.espaces.demande.approved": "accordée",
  "v2.espaces.demande.cancelled": "annulée",
  "v2.espaces.demande.pending": "en attente",
  "v2.espaces.demande.rejected": "refusée",
  "v2.espaces.depuis": "Depuis le {{date}}",
  "v2.espaces.deux_caracteres": "Deux caractères au moins.",
  "v2.espaces.droit_isole.accorde": "Droit isolé accordé et écrit au journal.",
  "v2.espaces.droit_isole.accorder": "Accorder",
  "v2.espaces.droit_isole.aucun_prerequis": "Aucun prérequis de lecture.",
  "v2.espaces.droit_isole.choisir": "Choisir un droit",
  "v2.espaces.droit_isole.date_de_fin": "Date de fin (facultative)",
  "v2.espaces.droit_isole.date_passee": "La date de fin doit être dans le futur.",
  "v2.espaces.droit_isole.deja_tenu": "Déjà tenu par un profil : ce droit isolé n’ajouterait rien.",
  "v2.espaces.droit_isole.droit": "Droit",
  "v2.espaces.droit_isole.droit_requis": "Choisissez un droit.",
  "v2.espaces.droit_isole.echec": "Le droit isolé n’a pas été accordé.",
  "v2.espaces.droit_isole.motif": "Motif",
  "v2.espaces.droit_isole.motif_aide": "15 caractères au moins.",
  "v2.espaces.droit_isole.motif_court": "Le motif compte 15 caractères au moins.",
  "v2.espaces.droit_isole.pour": "Pour : {{nom}}",
  "v2.espaces.droit_isole.prerequis": "Accordés avec lui, pour qu’il soit utilisable : {{droits}}",
  "v2.espaces.droit_isole.prolonger": "Déjà accordé : l’accord prolongera son échéance.",
  "v2.espaces.droit_isole.titre_programme": "Accorder un droit isolé sur le programme",
  "v2.espaces.droit_isole.titre_projet": "Accorder un droit isolé sur le projet",
  "v2.espaces.droit_isole_retire": "Droit isolé retiré ; l’historique est conservé.",
  "v2.espaces.droit_isole_retrait_echec": "Le droit isolé n’a pas été retiré.",
  "v2.espaces.droits_effectifs.aucun": "Aucun changement de droits.",
  "v2.espaces.droits_effectifs.aucun_droit": "Aucun",
  "v2.espaces.droits_effectifs.descend": "Dans les projets descendants : {{n}}",
  "v2.espaces.droits_effectifs.erreur": "La simulation des droits n’a pas répondu.",
  "v2.espaces.droits_effectifs.gagnes": "Droits gagnés",
  "v2.espaces.droits_effectifs.perdus": "Droits perdus",
  "v2.espaces.droits_effectifs.titre": "Droits effectifs",
  "v2.espaces.ecart_signale": "Écart signalé",
  "v2.espaces.etat.chargement": "Chargement de {{quoi}}…",
  "v2.espaces.etat.en_cours": "En cours…",
  "v2.espaces.etat.erreur": "{{quoi}} : la lecture n’a pas abouti.",
  "v2.espaces.etat.reessayer": "Réessayer",
  "v2.espaces.etat.refus": "{{quoi}} : accès refusé.",
  "v2.espaces.etat_droit.en_vigueur": "En vigueur",
  "v2.espaces.etat_droit.expire": "Expiré",
  "v2.espaces.etat_droit.expire_bientot": "Expire bientôt",
  "v2.espaces.expire_le": "expire le {{date}}",
  "v2.espaces.fermer": "Fermer",
  "v2.espaces.invitation.accepted": "Acceptée",
  "v2.espaces.invitation.declinee": "Déclinée",
  "v2.espaces.invitation.expired": "Expirée",
  "v2.espaces.invitation.pending": "En attente",
  "v2.espaces.invitation.revoked": "Révoquée",
  "v2.espaces.inviter.copie": "Lien copié.",
  "v2.espaces.inviter.copier": "Copier le lien",
  "v2.espaces.inviter.echec": "L’invitation n’est pas partie.",
  "v2.espaces.inviter.email": "Adresse e-mail",
  "v2.espaces.inviter.email_invalide": "Adresse e-mail invalide.",
  "v2.espaces.inviter.envoyee": "Invitation envoyée par e-mail : la personne arrivera comme Lecteur.",
  "v2.espaces.inviter.inviter": "Inviter",
  "v2.espaces.inviter.lecteur": "La personne arrive comme Lecteur ; un autre profil se donne ensuite par « Gérer les profils ».",
  "v2.espaces.inviter.lien": "Lien unique",
  "v2.espaces.inviter.lien_masque": "Le lien unique apparaît après l’envoi.",
  "v2.espaces.inviter.non_parti": "L’e-mail n’est pas parti : copiez le lien unique et transmettez-le.",
  "v2.espaces.inviter.titre": "Inviter une personne dans le projet",
  "v2.espaces.jusqu_au": "jusqu’au {{date}}",
  "v2.espaces.origine.organisation": "de l’organisation",
  "v2.espaces.origine.programme": "du programme",
  "v2.espaces.origine.projet": "du projet",
  "v2.espaces.origine_droit.attribution_historique": "attribution reprise sans motif",
  "v2.espaces.origine_droit.droit_isole": "accordé nominativement",
  "v2.espaces.personne_absente": "Aucune personne visée : revenez à la liste des membres pour en choisir une.",
  "v2.espaces.profil_herite": "{{profil}} (hérité {{origine}})",
  "v2.espaces.profils.ajouter": "Profil à ajouter",
  "v2.espaces.profils.choisir": "Choisir un profil",
  "v2.espaces.profils.dernier_programme": "Sans profil de programme, la personne reste membre comme Lecteur de programme.",
  "v2.espaces.profils.dernier_projet": "Sans profil de projet, la personne reste membre comme Lecteur.",
  "v2.espaces.profils.echec": "Les profils n’ont pas été enregistrés.",
  "v2.espaces.profils.enregistrer": "Enregistrer les profils",
  "v2.espaces.profils.enregistres": "Profils enregistrés.",
  "v2.espaces.profils.herite_non_modifiable": "Se modifie seulement à son niveau.",
  "v2.espaces.profils.introuvable": "Cette personne n’est pas (ou plus) membre du projet.",
  "v2.espaces.profils.liste": "Profils",
  "v2.espaces.profils.membre_vise": "Membre : {{nom}}",
  "v2.espaces.profils.proprietaire": "Propriétaire : il garde ses droits réservés quel que soit son profil.",
  "v2.espaces.profils.retirer": "Retirer le profil {{profil}}",
  "v2.espaces.profils.rien_a_changer": "Rien à changer.",
  "v2.espaces.profils.titre": "Gérer les profils d’un membre du projet",
  "v2.espaces.programme_membres.aucun_choisi": "Choisissez un membre pour voir ses profils et ses droits.",
  "v2.espaces.programme_membres.confirmer_retrait": "Confirmer le retrait du programme",
  "v2.espaces.programme_membres.descend": "Descend sur {{n}} projets",
  "v2.espaces.programme_membres.droits_isoles": "Droits isolés du programme",
  "v2.espaces.programme_membres.droits_isoles_vide": "Aucun droit isolé sur ce programme.",
  "v2.espaces.programme_membres.liste": "Membres",
  "v2.espaces.programme_membres.retire": "Membre retiré du programme ; ses profils et droits isolés du programme sont retirés.",
  "v2.espaces.programme_membres.retirer": "Retirer du programme",
  "v2.espaces.programme_membres.retrait_echec": "Le retrait n’a pas abouti.",
  "v2.espaces.programme_membres.retrait_proprietaire": "Le propriétaire ne se retire pas : transférez d’abord la propriété du programme.",
  "v2.espaces.programme_membres.titre": "Membres du programme",
  "v2.espaces.programme_membres.vide": "Aucun membre dans ce programme.",
  "v2.espaces.projet_membres.acces": "Accès sollicités",
  "v2.espaces.projet_membres.acces_accorde": "Accès accordé : la personne arrive comme Lecteur.",
  "v2.espaces.projet_membres.acces_aucune_attente": "Aucune demande d’accès en attente.",
  "v2.espaces.projet_membres.acces_refuse": "Accès refusé.",
  "v2.espaces.projet_membres.acces_vide": "Aucune demande d’accès.",
  "v2.espaces.projet_membres.accorder_acces": "Accorder l’accès à {{nom}}",
  "v2.espaces.projet_membres.accorder_court": "Accorder",
  "v2.espaces.projet_membres.admin_descendante": "Administration de l’organisation (descendante)",
  "v2.espaces.projet_membres.confirmer_revocation": "Confirmer la révocation",
  "v2.espaces.projet_membres.creer_equipe": "Créer une équipe",
  "v2.espaces.projet_membres.decidees": "Décisions passées",
  "v2.espaces.projet_membres.decision_echec": "La décision n’a pas été enregistrée.",
  "v2.espaces.projet_membres.designation": "{{role}} : {{personne}} depuis le {{date}}",
  "v2.espaces.projet_membres.designation_aucune": "Choisissez une désignation.",
  "v2.espaces.projet_membres.designation_choisie": "Désignation choisie",
  "v2.espaces.projet_membres.designation_manquante": "Exigée par le modèle, manquante : {{role}}",
  "v2.espaces.projet_membres.designations": "Désignations",
  "v2.espaces.projet_membres.designations_vide": "Aucune désignation.",
  "v2.espaces.projet_membres.designer": "Désigner",
  "v2.espaces.projet_membres.droit_isole_tenu": "Droit isolé : {{droit}}, {{echeance}}",
  "v2.espaces.projet_membres.droits_isoles": "Droits isolés du projet",
  "v2.espaces.projet_membres.droits_isoles_vide": "Aucun droit isolé sur ce projet.",
  "v2.espaces.projet_membres.effacer_recherche": "Effacer la recherche",
  "v2.espaces.projet_membres.equipes": "Équipes",
  "v2.espaces.projet_membres.equipes_vide": "Aucune équipe.",
  "v2.espaces.projet_membres.etat_actuel": "État actuel, pas un historique.",
  "v2.espaces.projet_membres.gerer_profils": "Gérer les profils",
  "v2.espaces.projet_membres.invitations": "Invitations",
  "v2.espaces.projet_membres.invitations_vide": "Aucune invitation.",
  "v2.espaces.projet_membres.inviter": "Inviter une personne",
  "v2.espaces.projet_membres.liste": "Membres",
  "v2.espaces.projet_membres.membres_comptes": "{{n}} membres",
  "v2.espaces.projet_membres.motif_refus": "Motif du refus (facultatif)",
  "v2.espaces.projet_membres.onglet.activite": "Activité",
  "v2.espaces.projet_membres.onglet.apercu": "Aperçu",
  "v2.espaces.projet_membres.onglet.indicateurs": "Indicateurs",
  "v2.espaces.projet_membres.onglet.membres": "Membres",
  "v2.espaces.projet_membres.onglet.methode": "Méthode et processus",
  "v2.espaces.projet_membres.onglets": "Onglets du projet",
  "v2.espaces.projet_membres.ordre": "Ordre",
  "v2.espaces.projet_membres.ordre_croissant": "Croissant",
  "v2.espaces.projet_membres.ordre_decroissant": "Décroissant",
  "v2.espaces.projet_membres.origine": "Origine des habilitations",
  "v2.espaces.projet_membres.origine_aucun": "Choisissez un membre pour voir l’origine de ses habilitations.",
  "v2.espaces.projet_membres.origine_vide": "Aucune habilitation sur ce projet.",
  "v2.espaces.projet_membres.recette": "Exécuter une recette",
  "v2.espaces.projet_membres.recette_accordee": "Recette : accordée",
  "v2.espaces.projet_membres.recette_confirmer": "Confirmer le droit de recette",
  "v2.espaces.projet_membres.recette_non_accordee": "Recette : non accordée",
  "v2.espaces.projet_membres.recette_retirer": "Confirmer le retrait du droit de recette",
  "v2.espaces.projet_membres.recherche": "Rechercher un membre",
  "v2.espaces.projet_membres.refuser_acces": "Refuser l’accès à {{nom}}",
  "v2.espaces.projet_membres.refuser_court": "Refuser",
  "v2.espaces.projet_membres.restreint": "Restreint par : {{profils}}",
  "v2.espaces.projet_membres.retirer": "Retirer du projet",
  "v2.espaces.projet_membres.retirer_droit_isole": "Retirer le droit isolé {{droit}} de {{personne}}",
  "v2.espaces.projet_membres.retrait_proprietaire": "Le dernier propriétaire ne se retire pas : transférez d’abord la propriété du projet.",
  "v2.espaces.projet_membres.retrait_soi": "C’est vous : on ne se retire pas soi-même d’un projet.",
  "v2.espaces.projet_membres.revocation_echec": "La révocation n’a pas abouti.",
  "v2.espaces.projet_membres.revoquee": "Invitation révoquée.",
  "v2.espaces.projet_membres.revoquer": "Révoquer l’invitation de {{email}}",
  "v2.espaces.projet_membres.revoquer_court": "Révoquer",
  "v2.espaces.projet_membres.titre": "Membres du projet",
  "v2.espaces.projet_membres.tri.depuis": "Date d’arrivée",
  "v2.espaces.projet_membres.tri.profil": "Profil",
  "v2.espaces.projet_membres.tri.utilisateur": "Personne",
  "v2.espaces.projet_membres.trier_par": "Trier par",
  "v2.espaces.projet_membres.vide": "Aucun membre dans ce projet.",
  "v2.espaces.projet_membres.voir_equipe": "Voir l’équipe {{equipe}}",
  "v2.espaces.proprietaire": "Propriétaire",
  "v2.espaces.retirer.attestation": "J’ai prévenu la personne et réaffecté son travail.",
  "v2.espaces.retirer.attestation_requise": "Cochez l’attestation pour retirer.",
  "v2.espaces.retirer.aucun": "aucune",
  "v2.espaces.retirer.designations": "Désignations à reprendre : {{liste}}",
  "v2.espaces.retirer.echec": "Le retrait n’a pas abouti.",
  "v2.espaces.retirer.effets": "Effets du retrait",
  "v2.espaces.retirer.equipes": "Équipes quittées : {{liste}}",
  "v2.espaces.retirer.personne": "Personne à retirer : {{nom}}",
  "v2.espaces.retirer.retire": "Personne retirée du projet.",
  "v2.espaces.retirer.titre": "Retirer une personne du projet — confirmation",
  "v2.espaces.retirer.travail": "Travail assigné à réaffecter : {{n}}",
  "v2.espaces.retirer_court": "Retirer",
  "v2.espaces.retirer_droit_isole": "Retirer le droit isolé {{droit}}",
  "v2.espaces.sans_echeance": "sans échéance",
  "v2.espaces.sans_programme": "Aucun programme choisi : choisissez un programme pour voir ses membres.",
  "v2.espaces.sans_projet": "Aucun projet choisi : choisissez un projet pour voir ses membres.",
  "v2.espaces.vague_ulterieure": "« {{ecran}} » n’est pas encore réalisé : il arrive avec la vague {{vague}}."
}
